<template>
    <svg
        width="22"
        height="18"
        viewbox="0 0 22 18"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        :class="`ds-header-navigation-icon ds-header-navigation-icon--animation-${mode}`">
        <path d="M1 1H19" class="line1"/>
        <path d="M1 8H19" class="line2"/>
        <path d="M1 15H19" class="line3"/>
    </svg>
</template>

<script>
export default {
    name: 'DsHeaderNavigationIcon',
    props: {
        active: { type: Boolean, required: true }
    },
    data: () => ({
        mode: null // no animation on page load
    }),
    watch: {
        active (value) {
            if (this.mode) {
                this.mode = value ? 'enter' : 'leave';
            } else {
                this.mode = 'enter';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../foundation/tokens/variables';

.ds-header-navigation-icon {
    transition: color 0.15s ease-in;

    .line1,
    .line3 {
        transform-box: fill-box;
        transform-origin: center center;
    }

    &--animation-enter {
        .line1 {
            animation: 0.3s line1-enter forwards ease-in;
        }

        .line2 {
            animation: 0.05s line2-enter 0.15s forwards ease-in;
        }

        .line3 {
            animation: 0.3s line3-enter forwards ease-in;
        }
    }

    &--animation-leave {
        .line1 {
            animation: 0.3s line1-leave forwards ease-in;
        }

        .line2 {
            animation: 0.05s line2-leave 0.15s forwards ease-in;
            opacity: 0;
        }

        .line3 {
            animation: 0.3s line3-leave forwards ease-in;
        }
    }
}

@keyframes line1-enter {
    0% {
        transform: translateY(0) rotate(0);
    }

    50% {
        transform: translateY(7px) rotate(0);
    }

    100% {
        transform: translateY(7px) rotate(45deg);
    }
}

@keyframes line1-leave {
    0% {
        transform: translateY(7px) rotate(45deg);
    }

    50% {
        transform: translateY(7px) rotate(0);
    }

    100% {
        transform: translateY(0) rotate(0);
    }
}

@keyframes line3-enter {
    0% {
        transform: translateY(0) rotate(0);
    }

    50% {
        transform: translateY(-7px) rotate(0);
    }

    100% {
        transform: translateY(-7px) rotate(-45deg);
    }
}

@keyframes line3-leave {
    0% {
        transform: translateY(-7px) rotate(-45deg);
    }

    50% {
        transform: translateY(-7px) rotate(0);
    }

    100% {
        transform: translateY(0) rotate(0);
    }
}

@keyframes line2-enter {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes line2-leave {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>
